import { Comments } from "../../../../components";
import { Button } from "../../../../shared";
import { Box, Typography } from "@mui/joy";
import { ChevronRight } from "lucide-react";

interface ITaskAction {
    taskName: string;
    onComplete: () => void;
    actionProgress?: any;
    isNextEligible?: boolean;
}

export default function TaskAction(props: ITaskAction) {
    const { taskName, onComplete, actionProgress, isNextEligible } = { ...props };

    const handleOnClose = () => {
        onComplete();
    };

    return (
        <Box sx={{ mt: 3, mb: 4 }}>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5 }}>
                {/* Comments Section */}
                <Box>
                    <Typography
                        level="title-sm"
                        sx={{
                            textTransform: "uppercase",
                            letterSpacing: "0.5px",
                            color: "text.tertiary",
                            mb: 2,
                            fontSize: "11px",
                            fontWeight: "xl",
                        }}
                    >
                        Comments & Notes
                    </Typography>
                    <Comments />
                </Box>

                <Box sx={{ display: "flex", justifyContent: { xs: "center", sm: "flex-end" } }}>
                    <Button
                        endDecorator={<ChevronRight size={18} />}
                        variant="soft"
                        color="primary"
                        onClick={handleOnClose}
                        loading={actionProgress?.loading}
                        loadingPosition="start"
                        disabled={!isNextEligible}
                        sx={{
                            width: { xs: "100%", sm: "auto" },
                        }}
                    >
                        Save & Continue
                    </Button>
                </Box>
            </Box>
        </Box>
    );
}
